module.exports = __webpack_public_path__ + "static/media/esad.09bc0ef2.png";